import { Tarifvertrag } from '@/domain/mitarbeiter/features/anlageassistent/entities/Tarifvertrag';

export class Standort {
  constructor({
    id,
    name,
    tarifvertrag,
  }: {
    id: string;
    name: string;
    tarifvertrag?: Tarifvertrag;
  }) {
    this.id = id;
    this.name = name;
    this.tarifvertrag = tarifvertrag;
  }

  id: string;
  name: string;
  tarifvertrag?: Tarifvertrag;
}
